export default {
  // Common
  nav: {
    home: "Hem",
    features: "Funktioner",
    pricing: "Priser",
    about: "Om oss",
    contact: "Kontakt",
    demo: "Boka Demo",
    blog: "Blogg",
    login: "Logga in"
  },

  // Plan Calculator
  planCalculator: {
    label: "PLANBERÄKNARE",
    question: "Ungefär hur många samtal får du per månad?",
    estimatesFor: "Uppskattning för {count} samtal per månad",
    dailyCalls: "Dagliga samtal",
    dailyCallsDesc: "Typiskt användningsmönster",
    monthlyMinutes: "Månatliga minuter",
    monthlyMinutesDesc: "De flesta samtal varar 2-3 minuter",
    recommendedPlan: "Rekommenderad plan",
    bestValue: "Ditt bästa valalternativ",
    recommendedLabel: "Rekommenderad plan",
    includedMinutes: "inkluderade minuter per månad",
    perMinAfter: "/min efter",
    claimTrial: "Starta gratis provperiod",
    features: "FUNKTIONER"
  },
  
  // Home page
  hero: {
    title: "Missa aldrig",
    rotatingWords: [
      { word: "bokning igen", article: "en" },
      { word: "samtal igen", article: "ett" },
      { word: "gäst igen", article: "en" },
      { word: "försäljning igen", article: "en" }
    ],
    subtitle: {
      part1: "Varje obesvarat samtal är förlorade intäkter. HostCall.ai hanterar obegränsat med gästsamtal ",
      highlight: "dygnet runt",
      part2: " på 20+ språk—och omvandlar förfrågningar till bokningar medan du sover."
    },
    cta: "Se hur det fungerar",
    demo: "Börja fånga fler bokningar",
    multilingual: "Nu med flerspråkigt stöd för 20+ språk",
    platformBadge: "HostCall AI Sälj- & Serviceplattform",
    floatingCards: {
      incomingCall: "Inkommande samtal",
      callerPhone: "+46 76 692 89 01",
      detectedIntent: "Upptäckt avsikt",
      verifyBooking: "Verifiera bokning",
      sendDoorCode: "Skicka dörrkod",
      assistantMessage: "Jag har verifierat din bokning och skickat dörrkoden till din telefon. Välkommen!",
      justNow: "Just nu"
    },
    stats: {
      calls: "50 000+",
      callsLabel: "Samtal Hanterade",
      properties: "200+",
      propertiesLabel: "Fastigheter",
      satisfaction: "4.9/5",
      satisfactionLabel: "Nöjdhet",
      hoursSaved: "Sparade Timmar/Vecka",
      moreBookings: "Fler Bokningar",
      guestSupport: "Gäststöd",
      guestSatisfaction: "Gästnöjdhet"
    },
    heroImageAlt: "Gäst anländer till lyxlägenhet"
  },

  // Meeting Booking
  meetingBooking: {
    title: "Boka ett möte",
    subtitle: "Boka en tid med vårt team för att lära dig mer om hostcall.ai.",
    thankYou: "Tack!",
    thankYouMessage: "Din mötesförfrågan har skickats. Vi återkommer snart.",
    scheduleTitle: "Schemalägg ditt möte",
    labels: {
      name: "Namn",
      namePlaceholder: "Ditt namn",
      email: "Jobbmail",
      emailPlaceholder: "du@foretag.se",
      date: "Önskat datum",
      time: "Önskad tid",
      timePlaceholder: "Välj en tid",
      notes: "Ytterligare information",
      notesPlaceholder: "Berätta för oss vad som kan hjälpa oss förbereda"
    },
    submitting: "Skickar...",
    submit: "Boka möte",
    toast: {
      title: "Möte begärt",
      description: "Vi kontaktar dig snart för att bekräfta ditt möte.",
      errorTitle: "Fel",
      errorDescription: "Det uppstod ett problem med din förfrågan. Försök igen."
    }
  },

  // Testimonials section
  testimonials: {
    title: "Betrodd av ledare inom hotellbranschen",
    subtitle: "Se varför fastighetsförvaltare och hotellägare över hela världen litar på hostcall.ai för att förbättra sin gästkommunikation.",
    trustedBy: "BETRODD AV",
    testimonial1: {
      quote: "hostcall.ai har helt förändrat vår gästkommunikationsprocess. Vi har sett en 35% ökning av gästnöjdhetspoäng och sparat otaliga timmar på rutinsamtal.",
      author: "Jacob Granberg",
      role: "Försäljningschef",
      company: "Guestly Homes",
      imageAlt: "Jacob Granbergs profilbild"
    },
    testimonial2: {
      quote: "Det flerspråkiga stödet är en spelförändare för vår internationella kundkrets. Våra gäster älskar att få omedelbara svar på sitt eget språk när som helst på dygnet.",
      author: "Michael Rodriguez",
      role: "Receptionsansvarig",
      company: "Seaside Luxury Resort",
      imageAlt: "Michael Rodriguez profilbild"
    },
    testimonial3: {
      quote: "Vi var skeptiska till att använda AI för gästkommunikation, men hostcall.ai låter anmärkningsvärt naturligt. Personaliseringsalternativen låter oss behålla vår varumärkesröst konsekvent.",
      author: "Emma Thompson",
      role: "Gästupplevelsechef",
      company: "Mountain View Lodge",
      imageAlt: "Emma Thompsons profilbild"
    },
    testimonial4: {
      quote: "Sedan vi implementerade hostcall.ai har vi kunnat hantera 300% fler gästförfrågningar utan att öka vår personal. Det har varit en total spelförändare för vårt boutique-hotell.",
      author: "David Chen",
      role: "Fastighetsförvaltare",
      company: "Urban Loft Stays",
      imageAlt: "David Chens profilbild"
    }
  },

  // Image alt texts
  imageAlts: {
    featureVisualization: "Funktionsvisualisering för"
  },

  // Use Case Showcase
  useCaseShowcase: {
    title: "Upplev hostcall.ai i praktiken",
    subtitle: "Utforska verkliga demos av hur vår AI-röstteknik förvandlar gästupplevelser inom olika hotellmiljöer."
  },

  // Customer Experience Ownership
  customerExperience: {
    title: "Ta fullständig kontroll över din kundupplevelse",
    subtitle: "hostcall.ai levererar komplett infrastruktur som frigör din kundupplevelse från beroende av stora AI-leverantörer. Njut av blixtsnabba svar, garanterad 99,99% drifttid och minimalt beroende av tredje part—allt medan du sänker dina samtalskostnader till nästan ingenting.",
    features: {
      fullyOwnedData: {
        title: "Helt egenägd data",
        description: "Din kunddata stannar inom din infrastruktur. Bearbeta allt internt utan exponering för tredje part."
      },
      soc2Certified: {
        title: "SOC2 Type II-certifierad",
        description: "Säkerhet på företagsnivå med oberoende SOC2 Type II-certifiering som uppfyller de högsta branschstandarderna."
      },
      gdprCompliant: {
        title: "GDPR-kompatibla system",
        description: "Inbyggd GDPR-efterlevnad för europeiska kunders integritetsrättigheter, vilket möjliggör sömlös global verksamhet."
      },
      hipaaReady: {
        title: "HIPAA-redo säkerhet",
        description: "Sjukvårdsgrads skydd med HIPAA-kompatibla system som skyddar känslig data över alla kontaktpunkter."
      },
      penetrationTesting: {
        title: "Kontinuerlig penetrationstestning",
        description: "Proaktiv säkerhet genom regelbunden testning av etiska hackare för att identifiera och åtgärda sårbarheter tidigt."
      },
      qualityAssurance: {
        title: "Omfattande kvalitetssäkring",
        description: "Automatiserad och manuell testning för att verifiera systemintegritet, vilket säkerställer säkerhet och felfria upplevelser."
      },
      whiteGlove: {
        title: "White-Glove implementering",
        description: "Expertledd installation av säkerhetsproffs som skräddarsyr system efter dina krav samtidigt som sårbarheter elimineras."
      },
      enterpriseGuardrails: {
        title: "Företagsskyddsräcken",
        description: "Avancerade säkerhetsgränser inbyggda i varje systemlager, som förhindrar obehörig åtkomst och säkerställer integritet."
      }
    }
  },

  // Footer
  footer: {
    product: "Produkt",
    company: "Företag",
    resources: "Resurser",
    legal: "Juridiskt",
    copyright: "© 2025 hostcall.ai. Alla rättigheter förbehållna.",
    description: "Den AI-drivna virtuella teammedlemmen som hanterar samtal, meddelanden och förfrågningar dygnet runt.",
    links: {
      features: "Funktioner",
      integrations: "Integrationer",
      pricing: "Priser",
      faq: "Vanliga frågor",
      about: "Om oss",
      blog: "Blogg",
      careers: "Karriär",
      contact: "Kontakt",
      apiDocs: "API-dokumentation",
      helpCenter: "Hjälpcenter",
      support: "Support",
      privacy: "Integritetspolicy",
      terms: "Användarvillkor",
      cookies: "Cookiepolicy"
    }
  },

  // About Page
  about: {
    hero: {
      title: "Vårt uppdrag är att förändra kommunikationen inom hotellbranschen",
      subtitle: "På hostcall.ai kombinerar vi toppmodern AI-teknik med djup expertis inom hotellbranschen för att skapa exceptionella gästupplevelser.",
      imageAlt: "Nordiskt landskap med berg och fjordar"
    },
    story: {
      title: "Vår Historia",
      paragraph1: "hostcall.ai föddes ur en enkel observation: hotell och semesterbostäder spenderar otaliga timmar på repetitiv gästkommunikation, vilket tar värdefull tid från att skapa exceptionella personliga upplevelser.",
      paragraph2: "Vår grundare, Joakim Thörn, upplevde denna utmaning på första hand när han förvaltade lyxfastigheter. Han märkte att personalen ständigt behandlade samma frågor om incheckningstider, bekvämligheter och lokala rekommendationer—ofta missade samtal med gäster eller missade möjligheter att förbättra deras vistelse.",
      paragraph3: "År 2024 fick Joakim idén och började samla ett team av AI-experter och hotellveteraner med ett djärvt uppdrag: att skapa en AI-kommunikationsplattform specifikt utformad för hotellföretagens unika behov. Under hela 2025 fokuserade teamet på intensiv forskning och utveckling och byggde den första prototypen av plattformen.",
      paragraph4: "I början av 2026 lanserade vi vår beta med utvalda boutiquehotell och semesterbostäder, och förfinade vår AI baserat på verklig feedback. Vår officiella offentliga lansering är planerad till Q2 2026, och vi är glada att fortsätta utveckla vår plattform med nya funktioner och integrationer för att förändra hotellkommunikation världen över."
    },
    values: {
      title: "Våra Kärnvärden",
      subtitle: "Dessa principer vägleder allt vi gör på hostcall.ai",
      value1: {
        title: "Gäst-först tillvägagångssätt",
        description: "Vi utformar varje funktion och interaktion med gästupplevelsen som vår högsta prioritet. Teknik ska förbättra, inte ersätta, mänsklig kontakt."
      },
      value2: {
        title: "Kontinuerligt lärande",
        description: "Vår AI förbättras ständigt genom verkliga interaktioner och blir mer hjälpsam och naturlig med varje konversation."
      },
      value3: {
        title: "Expertis inom hotellbranschen",
        description: "Vi kombinerar teknologisk innovation med djup branschkunskap för att lösa verkliga utmaningar som hotellbranschen står inför."
      }
    },
    team: {
      title: "Möt vårt team",
      subtitle: "De passionerade experterna bakom hostcall.ai",
      members: {
        joakim: {
          role: "VD & Grundare",
          bio: "Hotellchef med 25+ års erfarenhet av kundupplevelse. Grundade hostcall.ai för att lösa de gästkommunikationsutmaningar han upplevt på nära håll."
        },
        maria: {
          role: "Teknikchef",
          bio: "AI- och ML-expert med doktorsexamen i naturlig språkbehandling. Ledde AI-utvecklingsteam på stora teknikföretag innan hon gick med i hostcall.ai."
        },
        david: {
          role: "Hotellansvarig",
          bio: "Tillbringade 20 år med att förvalta fastigheter för stora hotellkedjor över hela världen. Expert på optimering av gästupplevelse och operativ excellens."
        },
        sarah: {
          role: "Kundframgångsansvarig",
          bio: "Engagerad i att säkerställa att hostcall.ai levererar exceptionella resultat för varje kund. Ledde tidigare kundupplevelsesteam inom SaaS och hotellbranschen."
        }
      }
    },
    journey: {
      title: "Vår Resa",
      subtitle: "Utvecklingen av hostcall.ai från koncept till branschledare",
      timeline: {
        idea: {
          title: "Idén",
          description: "hostcall.ai skapades efter att grundaren Joakim Thörn upplevde utmaningarna med att hantera gästkommunikation i stor skala."
        },
        research: {
          title: "Forskning & Utveckling",
          description: "Samlade ett team av AI-experter och hotellveteraner för att bygga den första prototypen av hostcall.ai-plattformen."
        },
        beta: {
          title: "Betalansering",
          description: "Lanserade vår beta med utvalda boutiquehotell och semesterbostäder, och förfinade vår AI baserat på verklig feedback."
        },
        launch: {
          title: "Officiell Lansering",
          description: "hostcall.ai lanseras officiellt för allmänheten och erbjuder en komplett gästkommunikationslösning för fastigheter i alla storlekar."
        },
        future: {
          title: "Blickar Framåt",
          description: "Utökar vår plattform med nya funktioner och integrationer för att ytterligare förändra hotellkommunikation världen över."
        }
      }
    },
    join: {
      title: "Anslut dig till vårt uppdrag",
      subtitle: "Samarbeta med hostcall.ai för att förändra din gästkommunikation och bli en del av framtiden för hotellbranschen.",
      demo: "Boka Demo",
      careers: "Gå med i vårt team"
    }
  },

  // Business Cases
  businessCases: {
    hero: {
      title: "Verkliga framgångshistorier från hotellbranschen",
      subtitle: "Upptäck hur hotell och semesteruthyrningsföretag förändrar sin gästkommunikation och verksamhet med hostcall.ai",
      demo: "Boka en Demo",
      pricing: "Se priser"
    },
    breakdown: "Affärsfallsanalys",
    challenge: "UTMANINGEN",
    solution: "LÖSNINGEN",
    outcome: "RESULTATET"
  },

  // Features and Home page sections
  features: {
    title: "Omfattande gästkommunikation",
    subtitle: "hostcall.ai hanterar varje aspekt av gästkommunikation genom hela deras resa, från bokning till utcheckning och därefter.",
    callHandling: "Samtalhantering dygnet runt",
    preStay: "Kommunikation före ankomst",
    inStay: "Support under vistelsen",
    postStay: "Uppföljning efter vistelsen",
    multilingual: "Flerspråkigt stöd",
    integration: "Sömlös integration",
    featureCard1: {
      title: "Gästkommunikation dygnet runt",
      description: "Missa aldrig ett gästmeddelande med AI-assistans dygnet runt."
    },
    featureCard2: {
      title: "Flerspråkigt stöd",
      description: "Kommunicera med gäster på över 20 språk med perfekt precision."
    },
    featureCard3: {
      title: "Försäljning på autopilot",
      description: "Ansluter enkelt till ditt befintliga PMS och hotellhanteringssystem."
    },
    featureCard4: {
      title: "Detaljerad analys",
      description: "Spåra prestationsstatistik och förbättra dina gästnöjdhetspoäng."
    }
  },
  
  howItWorks: {
    title: "Hur hostcall.ai fungerar",
    subtitle: "Vår plattform integreras sömlöst med dina befintliga hotellsystem för att tillhandahålla automatiserad, intelligent gästkommunikation.",
    steps: {
      step1: {
        title: "Enkel integration",
        desc: "Anslut hostcall.ai till dina befintliga system med vårt enkla API eller förbyggda integrationer. Installationen tar minuter, inte dagar."
      },
      step2: {
        title: "Anpassa din AI",
        desc: "Träna AI:n på din fastighets specifika detaljer, policyer och lokal information för att leverera korrekt gästassistans."
      },
      step3: {
        title: "Automatisera kommunikationen",
        desc: "Låt hostcall.ai hantera rutinsamtal och förfrågningar medan ditt team fokuserar på att leverera exceptionella personliga upplevelser."
      },
      step4: {
        title: "Övervaka och optimera",
        desc: "Få tillgång till detaljerad analys och konversationstranskript för att kontinuerligt förbättra din gästkommunikationsstrategi."
      }
    },
    cta: {
      title: "Redo att förändra din gästkommunikation?",
      subtitle: "Gå med ledande fastigheter som redan använder hostcall.ai för att förbättra gästnöjdheten och operativ effektivitet.",
      button: "Kom igång nu"
    }
  },

  // Contact page
  contact: {
    title: "Kontakta oss",
    subtitle: "Vi skulle gärna höra från dig. Vårt team står redo att svara på dina frågor.",
    email: "E-post",
    phone: "Telefon",
    office: "Kontor",
    hero: {
      title: "Kontakta Oss",
      subtitle: "Har du frågor eller är redo att förändra din gästkommunikation? Vårt team finns här för att hjälpa dig implementera den perfekta lösningen för din fastighet.",
      callUs: {
        title: "Ring Oss",
        description: "Prata direkt med vårt team"
      },
      emailUs: {
        title: "Mejla Oss",
        description: "Vi svarar inom 24 timmar"
      },
      liveChat: {
        title: "Livechatt",
        description: "Chatta med vårt supportteam",
        button: "Starta Chatt"
      }
    },
    form: {
      title: "Kontaktinformation",
      subtitle: "Fyll i formuläret så återkommer vårt team så snart som möjligt.",
      name: "Namn",
      email: "E-post",
      message: "Meddelande",
      submit: "Skicka meddelande",
      office: "Vårt Kontor",
      phone: "Telefon",
      emailLabel: "E-post",
      followUs: "Följ Oss",
      sendMessage: "Skicka ett Meddelande"
    },
    map: {
      title: "Vår Plats",
      headquarters: "Hostcall.ai Huvudkontor",
      apiKeyPrompt: "Ange din Google Maps API-nyckel för att visa kartan",
      saveKey: "Spara Nyckel",
      apiKeyNote: "Din API-nyckel lagras lokalt och skickas inte till våra servrar.",
      loadError: "Fel vid laddning av Google Maps",
      changeApiKey: "Ändra API-nyckel",
      loading: "Laddar kartor..."
    },
    faq: {
      title: "Vanliga frågor",
      subtitle: "Hitta snabba svar på vanliga frågor om hostcall.ai",
      question1: {
        q: "Hur snabbt kan vi implementera hostcall.ai?",
        a: "De flesta fastigheter är igång inom 1-2 veckor, med grundläggande implementeringar möjliga på så lite som 48 timmar."
      },
      question2: {
        q: "Vilka fastighetshanteringssystem integrerar ni med?",
        a: "Vi stöder alla större PMS-plattformar inklusive Opera, Mews, Cloudbeds och många andra. Anpassade integrationer finns tillgängliga för Enterprise-kunder."
      },
      question3: {
        q: "Erbjuder ni support dygnet runt?",
        a: "Ja, alla betalda planer inkluderar tillgång till vårt supportteam, med Enterprise-kunder som får dedikerad teknisk support dygnet runt."
      },
      question4: {
        q: "Kan hostcall.ai hantera flera fastigheter?",
        a: "Absolut. Vår plattform är utformad för att skalas från enskilda fastigheter till stora hotellgrupper med anpassade hanteringspaneler."
      }
    }
  },

  // Careers page
  careers: {
    hero: {
      titlePart1: "Gå Med i Vårt",
      titleHighlight: "Team",
      subtitle: "Hjälp oss att förändra hotellbranschen med banbrytande AI-teknik. Vi letar efter passionerade individer att ansluta till vårt helt fjärrstyrda team.",
      viewPositions: "Se Lediga Tjänster"
    },
    listings: {
      title: "Lediga Tjänster",
      subtitle: "Utforska våra nuvarande jobberbjudanden och hitta en roll som matchar dina färdigheter och passion.",
      applyNow: "Ansök Nu"
    },
    form: {
      title: "Ansök Nu",
      subtitle: "Fyll i formuläret nedan för att ansöka till en av våra lediga tjänster. Vi ser fram emot att lära oss mer om dig!",
      labels: {
        fullName: "Fullständigt Namn",
        email: "E-post",
        phone: "Telefon",
        position: "Tjänst",
        linkedin: "LinkedIn-profil",
        portfolio: "Portfolio / Webbplats",
        coverLetter: "Varför är du intresserad av denna tjänst?"
      },
      placeholders: {
        fullName: "Ditt fullständiga namn",
        email: "din@epost.se",
        phone: "Ditt telefonnummer",
        position: "Välj en tjänst att ansöka till",
        linkedin: "https://linkedin.com/in/din-profil",
        portfolio: "https://din-webbplats.se",
        coverLetter: "Berätta varför du är intresserad av att gå med i vårt team och vad du kan bidra med till rollen..."
      },
      optional: "Valfritt",
      submit: "Skicka Ansökan",
      toast: {
        title: "Ansökan skickad",
        description: "Tack för din ansökan! Vi hör av oss snart."
      }
    },
    jobs: {
      customerSuccess: {
        title: "Kundframgångs- & Onboardingspecialist",
        department: "Kundframgång",
        location: "Distans",
        description: "Gå med i vårt kundframgångsteam för att hjälpa hotellföretag att framgångsrikt implementera och få ut det mesta av hostcall.ai. Du ansvarar för att onboarda nya kunder, ge utbildning och säkerställa deras fortsatta nöjdhet med vår plattform.",
        requirements: [
          "2+ års erfarenhet inom kundframgång, onboarding eller kontohantering",
          "Utmärkta kommunikations- och mellanmänskliga färdigheter",
          "Erfarenhet från hotellbranschen är meriterande",
          "Problemlösningsförmåga och uppmärksamhet på detaljer",
          "Förmåga att arbeta i en snabbrörlig distansmiljö"
        ],
        responsibilities: [
          "Guida nya kunder genom onboardingprocessen",
          "Ge produktutbildning och bästa praxis",
          "Övervaka kundframgångsmått och nöjdhet",
          "Identifiera möjligheter för kunder att utöka sin användning av vår plattform",
          "Samarbeta med produkt- och teknikteam för att tillgodose kundbehov"
        ]
      },
      salesEngineer: {
        title: "Säljingenjör",
        department: "Försäljning",
        location: "Distans",
        description: "Som Säljingenjör kommer du att arbeta nära vårt säljteam för att ge teknisk expertis under säljprocessen. Du hjälper potentiella kunder att förstå de tekniska aspekterna av vår produkt, demonstrera dess kapacitet och besvara tekniska frågor.",
        requirements: [
          "3+ års erfarenhet inom säljingenjör eller teknisk försäljning",
          "Stark teknisk kunskap och förmåga att förklara komplexa koncept enkelt",
          "Erfarenhet av SaaS-produkter och API:er",
          "Utmärkta presentations- och demonstrationsfärdigheter",
          "Kunskap om hotellbranschen är meriterande"
        ],
        responsibilities: [
          "Genomföra tekniska produktdemonstrationer för potentiella kunder",
          "Besvara tekniska frågor under säljprocessen",
          "Stödja säljteamet med teknisk expertis",
          "Samla in tekniska krav från potentiella kunder",
          "Samarbeta med produkt- och teknikteam om produktfeedback"
        ]
      },
      backendAiDeveloper: {
        title: "Backend- och AI-utvecklare",
        department: "Teknik",
        location: "Distans",
        description: "Vi söker en skicklig Backend- och AI-utvecklare för att hjälpa oss bygga och förbättra vår AI-drivna hotellplattform. Du kommer att arbeta med att utveckla och optimera våra backend-system och AI-modeller som driver vår konversations-AI-agent.",
        requirements: [
          "5+ års erfarenhet inom backend-utveckling",
          "Erfarenhet av AI/ML-teknologier, särskilt NLP och konversations-AI",
          "Kunskaper i Python, Node.js eller liknande backend-teknologier",
          "Erfarenhet av molnplattformar (AWS, GCP eller Azure)",
          "Kunskap om RESTful API:er och mikrotjänstarkitektur"
        ],
        responsibilities: [
          "Utveckla och underhålla våra backend-system och API-endpoints",
          "Arbeta med AI-modellträning, finjustering och driftsättning",
          "Förbättra prestanda och noggrannhet hos vår konversations-AI-agent",
          "Implementera integrationer med hotellhanteringssystem",
          "Samarbeta med produktteamet för att implementera nya funktioner"
        ]
      }
    }
  },

  // Pricing page
  pricing: {
    title: "Enkla, transparenta priser",
    subtitle: "Välj den plan som passar dina behov och börja förändra din gästkommunikation idag.",
    plans: {
      basic: {
        name: "Start",
        price: "2 990 kr",
        description: "Perfekt för små fastigheter med upp till 10 rum",
        features: [
          "Dygnet-runt samtalshantering",
          "Grundläggande fastighetsintegrationer",
          "Kommunikation före ankomst",
          "Insamling av feedback efter vistelse",
          "E-postsupport",
          "5 språk stöds"
        ]
      },
      pro: {
        name: "Professionell",
        price: "5 990 kr",
        description: "Perfekt för medelstora fastigheter med upp till 50 rum",
        features: [
          "Allt i Start, plus:",
          "Avancerade PMS-integrationer",
          "Gästkommunikation under vistelsen",
          "Anpassad röst och personlighet",
          "Analysdashboard",
          "Prioriterad support",
          "20 språk stöds"
        ],
        popular: "Mest populär"
      },
      enterprise: {
        name: "Enterprise",
        price: "Anpassat",
        description: "Skräddarsydda lösningar för stora fastigheter och hotellgrupper",
        features: [
          "Allt i Professionell, plus:",
          "Obegränsat antal rum",
          "Full API-åtkomst",
          "Anpassade integrationer",
          "Vitproduktalternativ",
          "Dedikerad kontoansvarig",
          "Alla språk stöds"
        ]
      }
    },
    getStarted: "Kom igång",
    contactSales: "Kontakta försäljning",
    perMonth: "/månad",
    callUs: "Osäker på vilken plan som passar dig?",
    callUsDesc: "Boka en konsultation med våra hotellexperter för att hitta den perfekta lösningen för din fastighet.",
    consultation: "Boka konsultation"
  },

  pricingPage: {
    keyFeatures: {
      title: "Viktiga funktioner",
      subtitle: "Utforska funktionerna som gör hostcall.ai till den ultimata lösningen för gästkommunikation."
    },
    choosePlan: {
      title: "Välj din plan",
      subtitle: "Välj prisnivån som passar din fastighets behov bäst."
    },
    cta: {
      title: "Redo att komma igång?",
      subtitle: "Starta din gratis provperiod idag och upplev framtiden för gästkommunikation."
    }
  },

  // Demo page
  demo: {
    hero: {
      title: "Upplev hostcall.ai i aktion",
      subtitle: "Boka en personlig demo för att se hur vår AI-drivna gästkommunikationsplattform kan förändra din fastighets verksamhet."
    },
    form: {
      step1: {
        title: "Begär din demo",
        firstName: "Förnamn",
        lastName: "Efternamn",
        email: "Jobbmejl",
        phone: "Telefonnummer",
        company: "Företag / Fastighetsnamn",
        propertyType: "Fastighetstyp",
        roomCount: "Antal rum/enheter",
        continue: "Fortsätt till schemaläggning",
        privacyNote: "Genom att skicka detta formulär godkänner du vår"
      },
      step2: {
        title: "Schemalägg din demo",
        date: "Önskat datum",
        time: "Önskad tid",
        timezone: "Tidszon",
        requirements: "Specifika krav eller frågor",
        requirementsPlaceholder: "Berätta om specifika funktioner du vill se eller frågor du har",
        timezoneNote: "Alla tider är i din lokala tidszon.",
        back: "Tillbaka",
        submit: "Boka demo",
        submitting: "Skickar..."
      },
      propertyTypes: {
        hotel: "Hotell",
        resort: "Resort",
        vacationRental: "Semesterbostad",
        apartment: "Servicebostad",
        bnb: "B&B / Värdshus",
        other: "Annat"
      },
      roomCounts: {
        small: "1-10",
        medium: "11-50",
        large: "51-100",
        xlarge: "101-250",
        enterprise: "250+"
      }
    },
    success: {
      title: "Tack!",
      message: "Din demoförfrågan har skickats. En av våra teammedlemmar kommer att kontakta dig inom kort för att bekräfta detaljerna för din personliga demosession.",
      explore: "Under tiden kan du gärna utforska våra resurser för att lära dig mer om hostcall.ai.",
      watchVideo: "Se produktvideo",
      readCases: "Läs kundcase"
    },
    benefits: {
      title: "Vad du får se i din demo",
      subtitle: "Våra personliga demosessioner är anpassade efter din fastighets specifika behov",
      platform: {
        title: "Plattformsöversikt",
        description: "Se hela kapaciteten hos hostcall.ai och hur det integreras med dina befintliga system."
      },
      custom: {
        title: "Anpassade scenarier",
        description: "Vi demonstrerar hur hostcall.ai hanterar din fastighets specifika gästkommunikationsbehov."
      },
      implementation: {
        title: "Implementeringsplan",
        description: "Vi diskuterar installationsprocessen och skapar en tidslinje för att komma igång med hostcall.ai."
      }
    },
    testimonials: {
      title: "Vad våra kunder säger",
      subtitle: "Gå med hundratals nöjda fastigheter som använder hostcall.ai"
    },
    faq: {
      title: "Vanliga frågor",
      subtitle: "Vanliga frågor om vår demoprocess",
      questions: {
        duration: {
          q: "Hur lång tid tar demon vanligtvis?",
          a: "Våra demos varar vanligtvis 30-45 minuter, inklusive tid för dina frågor och diskussion om dina specifika behov."
        },
        attendees: {
          q: "Vilka från vårt team bör delta i demon?",
          a: "Vi rekommenderar att inkludera beslutsfattare och operativa teammedlemmar som hanterar gästkommunikation, såsom receptionschefer, hotelldirektörer eller fastighetsägare."
        },
        preparation: {
          q: "Behövs någon förberedelse före demon?",
          a: "Ingen speciell förberedelse behövs. Men att ha information om din nuvarande gästkommunikationsprocess och eventuella specifika utmaningar hjälper oss att anpassa demon efter dina behov."
        },
        trial: {
          q: "Kan vi få tillgång till en testversion efter demon?",
          a: "Ja, vi erbjuder en 14-dagars gratis provperiod efter demon så att du kan uppleva hostcall.ai i din egen miljö. Vårt team hjälper dig att ställa in allt."
        }
      }
    },
    toast: {
      success: {
        title: "Demo begärd",
        description: "Vi har mottagit din förfrågan och kommer att kontakta dig inom kort för att bekräfta din demo."
      },
      error: {
        title: "Fel",
        description: "Det uppstod ett problem med att skicka din förfrågan. Försök igen."
      }
    }
  },

  // Legal pages
  legal: {
    privacy: {
      title: "Integritetspolicy",
      lastUpdated: "Senast uppdaterad: 1 maj 2025",
      sections: {
        intro: {
          title: "1. Introduktion",
          content: "På hostcall.ai tar vi din integritet på allvar. Denna integritetspolicy förklarar hur vi samlar in, använder, lämnar ut och skyddar din information när du besöker vår webbplats eller använder våra konversations-AI-tjänster för hotellbranschen."
        },
        collection: {
          title: "2. Information vi samlar in",
          content: "Vi samlar in information som du ger oss direkt, information vi samlar in automatiskt när du använder våra tjänster, och information från tredjepartskällor.",
          personal: {
            title: "Personlig information",
            content: "Detta kan inkludera ditt namn, e-postadress, telefonnummer, företagsinformation och annan information du väljer att tillhandahålla."
          },
          usage: {
            title: "Användningsinformation",
            content: "Vi samlar in information om hur du använder våra tjänster, inklusive loggdata, enhetsinformation, platsinformation och cookies."
          }
        },
        use: {
          title: "3. Hur vi använder din information",
          intro: "Vi använder din information för att:",
          items: [
            "Tillhandahålla, underhålla och förbättra våra tjänster",
            "Utveckla nya produkter och funktioner",
            "Kommunicera med dig om våra tjänster",
            "Övervaka och analysera användningsmönster",
            "Skydda mot bedräglig eller obehörig aktivitet"
          ]
        },
        sharing: {
          title: "4. Datadelning och utlämnande",
          content: "Vi kan dela din information med tredjepartsleverantörer, affärspartners och enligt lag."
        },
        security: {
          title: "5. Säkerhet",
          content: "Vi implementerar lämpliga tekniska och organisatoriska åtgärder för att skydda säkerheten för din personliga information. Ingen metod för överföring via internet eller elektronisk lagring är dock 100% säker."
        },
        rights: {
          title: "6. Dina rättigheter",
          content: "Beroende på din plats kan du ha vissa rättigheter angående din personliga information, inklusive rätten att få tillgång till, korrigera eller radera din personliga information."
        },
        changes: {
          title: "7. Ändringar av denna policy",
          content: "Vi kan uppdatera denna integritetspolicy då och då. Vi meddelar dig om eventuella ändringar genom att publicera den nya integritetspolicyn på denna sida."
        },
        contact: {
          title: "8. Kontakta oss",
          content: "Om du har några frågor om denna integritetspolicy, vänligen kontakta oss på"
        }
      }
    },
    terms: {
      title: "Användarvillkor",
      lastUpdated: "Senast uppdaterad: 1 maj 2025",
      sections: {
        agreement: {
          title: "1. Godkännande av villkor",
          content: "Genom att få tillgång till eller använda hostcall.ai godkänner du att vara bunden av dessa användarvillkor och alla tillämpliga lagar och förordningar. Om du inte samtycker till något av dessa villkor är du förbjuden att använda eller få tillgång till denna webbplats."
        },
        license: {
          title: "2. Användningslicens",
          content: "Tillstånd beviljas att tillfälligt få tillgång till materialet på hostcall.ai:s webbplats för personlig, icke-kommersiell tillfällig visning endast. Detta är beviljande av en licens, inte en överlåtelse av äganderätt.",
          terminationIntro: "Denna licens upphör automatiskt om du:",
          terminationItems: [
            "bryter mot någon av dessa begränsningar",
            "avslutar din prenumeration",
            "bryter mot avtalet på något sätt"
          ]
        },
        disclaimer: {
          title: "3. Ansvarsfriskrivning",
          content: "Materialet på hostcall.ai:s webbplats tillhandahålls 'som det är'. hostcall.ai ger inga garantier, uttryckliga eller underförstådda, och friskriver sig härmed från och negerar alla andra garantier inklusive, utan begränsning, underförstådda garantier eller villkor för säljbarhet, lämplighet för ett visst ändamål, eller icke-intrång i immateriella rättigheter eller annan rättskränkning."
        },
        limitations: {
          title: "4. Begränsningar",
          content: "Under inga omständigheter ska hostcall.ai eller dess leverantörer vara ansvariga för några skador (inklusive, utan begränsning, skador för förlust av data eller vinst, eller på grund av affärsavbrott) som uppstår från användningen av eller oförmågan att använda materialet på hostcall.ai:s webbplats, även om hostcall.ai eller en auktoriserad representant för hostcall.ai har meddelats muntligt eller skriftligt om möjligheten till sådan skada."
        },
        revisions: {
          title: "5. Revideringar och fel",
          content: "Materialet som visas på hostcall.ai:s webbplats kan innehålla tekniska, typografiska eller fotografiska fel. hostcall.ai garanterar inte att något av materialet på dess webbplats är korrekt, fullständigt eller aktuellt."
        },
        links: {
          title: "6. Länkar",
          content: "hostcall.ai har inte granskat alla webbplatser som är länkade till dess webbplats och ansvarar inte för innehållet på någon sådan länkad webbplats. Inkluderingen av någon länk innebär inte godkännande av webbplatsen av hostcall.ai. Användning av någon sådan länkad webbplats sker på användarens egen risk."
        },
        governing: {
          title: "7. Tillämplig lag",
          content: "Dessa villkor regleras av och tolkas i enlighet med lagarna och du underkastar dig oåterkalleligt den exklusiva jurisdiktionen för domstolarna på den platsen."
        },
        contact: {
          title: "8. Kontakta oss",
          content: "Om du har några frågor om dessa användarvillkor, vänligen kontakta oss på"
        }
      }
    },
    cookies: {
      title: "Cookiepolicy",
      lastUpdated: "Senast uppdaterad: 1 maj 2025",
      sections: {
        what: {
          title: "Vad är cookies?",
          content: "Cookies är små textfiler som placeras på din dator eller mobila enhet när du surfar på webbplatser. De används ofta för att få webbplatser att fungera mer effektivt och ge information till webbplatsägarna."
        },
        how: {
          title: "Hur vi använder cookies",
          intro: "hostcall.ai använder cookies för följande ändamål:",
          items: {
            essential: {
              title: "Nödvändiga cookies:",
              content: "Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt. De möjliggör kärnfunktionalitet som säkerhet, nätverkshantering och tillgänglighet."
            },
            analytics: {
              title: "Analyticscookies:",
              content: "Dessa cookies hjälper oss att förstå hur besökare interagerar med vår webbplats genom att samla in och rapportera information anonymt."
            },
            marketing: {
              title: "Marknadsföringscookies:",
              content: "Dessa cookies spårar din onlineaktivitet för att hjälpa annonsörer att leverera mer relevant reklam eller begränsa hur många gånger du ser en annons."
            },
            preference: {
              title: "Inställningscookies:",
              content: "Dessa cookies gör det möjligt för en webbplats att komma ihåg information som ändrar hur webbplatsen beter sig eller ser ut, som ditt föredragna språk."
            }
          }
        },
        types: {
          title: "Typer av cookies vi använder",
          firstParty: {
            title: "Förstapartscookies",
            content: "Dessa är cookies som sätts direkt av hostcall.ai. De används för att förbättra din användarupplevelse på vår webbplats."
          },
          thirdParty: {
            title: "Tredjepartscookies",
            content: "Dessa är cookies som sätts av andra domäner än hostcall.ai. De används för olika ändamål inklusive analys, marknadsföring och integration med sociala medier."
          }
        },
        managing: {
          title: "Hantera cookies",
          content: "De flesta webbläsare tillåter viss kontroll av de flesta cookies genom webbläsarinställningarna. För att ta reda på mer om cookies, inklusive hur du ser vilka cookies som har satts, besök"
        },
        delete: {
          title: "Hur man raderar och blockerar cookies",
          content: "Du kan blockera cookies genom att aktivera inställningen i din webbläsare som låter dig vägra inställningen av alla eller vissa cookies. Om du använder dina webbläsarinställningar för att blockera alla cookies (inklusive nödvändiga cookies) kanske du inte kan komma åt alla eller delar av vår webbplats."
        },
        changes: {
          title: "Ändringar av vår cookiepolicy",
          content: "Vi kan uppdatera vår cookiepolicy då och då. Eventuella ändringar vi gör i vår cookiepolicy i framtiden kommer att publiceras på denna sida."
        },
        contact: {
          title: "Kontakta oss",
          content: "Om du har några frågor om vår cookiepolicy, vänligen kontakta oss på"
        }
      }
    }
  },
  
  // FAQ section
  faq: {
    title: "Vanliga frågor",
    subtitle: "Få svar på vanliga frågor om vår AI-röstassistent",
    questions: [
      {
        q: "Hur fungerar AI-röstassistenten?",
        a: "Vår AI-röstassistent använder avancerad naturlig språkbehandling för att förstå gästförfrågningar och svara korrekt. Den integreras med ditt fastighetshanteringssystem för att komma åt bokningsinformation och kan hantera komplexa samtal om bekvämligheter, lokala rekommendationer och gästtjänster."
      },
      {
        q: "Kan AI:n hantera flera språk?",
        a: "Ja, vår AI-röstassistent stöder över 20 språk och kan automatiskt identifiera den uppringandes föredragna språk. Detta säkerställer att internationella gäster får support på sitt modersmål, vilket förbättrar deras upplevelse."
      },
      {
        q: "Hur snabbt kan jag sätta upp systemet?",
        a: "Installation tar vanligtvis 24-48 timmar. Vi konfigurerar AI:n med din fastighetsinformation, integrerar med dina befintliga system och ger utbildning till ditt team. De flesta fastigheter är i drift inom 2 arbetsdagar."
      },
      {
        q: "Vad händer om AI:n inte kan svara på en fråga?",
        a: "AI:n är utformad för att hantera 90%+ av vanliga gästförfrågningar. För komplexa frågor som den inte kan lösa, överför den sömlöst samtalet till din personal med en sammanfattning av konversationen och gästens behov."
      },
      {
        q: "Finns det en installationsavgift?",
        a: "Inga installationsavgifter. Vi inkluderar onboarding, integration och utbildning i din månadsabonnemang. Du betalar bara månadsavgiften baserat på din valda plan."
      },
      {
        q: "Kan jag anpassa AI:ns personlighet och svar?",
        a: "Absolut. Du kan anpassa AI:ns röst, personlighet, ton och svar för att matcha ditt varumärke. Vi arbetar med dig under installationen för att säkerställa att AI:n representerar din fastighet perfekt."
      }
    ],
    moreQuestions: "Har du fortfarande frågor? Vi finns här för att hjälpa!",
    contactSupport: "Kontakta vårt supportteam",
    cta: {
      title: "Redo att förändra din gästsamtalsupplevelse?",
      subtitle: "Gå med hundratals fastigheter som redan använder hostcall.ai för att erbjuda exceptionella gästupplevelser samtidigt som de minskar driftskostnaderna.",
      demoButton: "Begär gratis demo",
      pricingButton: "Visa prisplaner",
      trial: "Inget kreditkort krävs • 14 dagars gratis provperiod"
    }
  },

  // Blog page
  blog: {
    title: "Insikter och resurser",
    subtitle: "Utforska de senaste trenderna, tipsen och bästa metoderna för gästkommunikation inom hotellbranschen.",
    searchPlaceholder: "Sök artiklar...",
    categories: {
      all: "Alla inlägg",
      guestExperience: "Gästupplevelse",
      technology: "Teknik",
      industryTrends: "Branschtrender",
      bestPractices: "Bästa praxis",
      caseStudies: "Fallstudier",
      productUpdates: "Produktuppdateringar"
    },
    readTime: "min läsning",
    readMore: "Läs mer",
    noResults: {
      title: "Inga matchande artiklar hittades",
      subtitle: "Försök att justera din sökning eller bläddra i alla kategorier",
      showAll: "Visa alla artiklar"
    },
    pagination: {
      previous: "Föregående",
      next: "Nästa"
    },
    newsletter: {
      title: "Prenumerera på vårt nyhetsbrev",
      subtitle: "Få de senaste insikterna och uppdateringarna från hotellbranschen direkt i din inkorg.",
      placeholder: "Ange din e-postadress",
      button: "Prenumerera"
    },
    roiSidebar: {
      title: "Beräkna din ROI",
      subtitle: "Se hur mycket du kan spara",
      avgSavings: "Genomsnittliga årliga besparingar",
      payback: "Typisk återbetalningstid",
      months: "månader",
      cta: "Öppna kalkylatorn",
      teaser: "Fastigheter sparar i snitt 450 000 kr/år"
    },
    exitPopup: {
      title: "Vänta! Gå inte ännu",
      subtitle: "Se hur mycket din fastighet kan spara med AI-driven gästkommunikation",
      benefit1: "Beräkna personlig ROI på 2 minuter",
      benefit2: "Inget kreditkort krävs",
      benefit3: "Få resultat direkt",
      primaryCta: "Beräkna min ROI",
      secondaryCta: "Nej tack, jag avstår"
    }
  },

  // Blog Preview section
  blogPreview: {
    title: "Senaste insikter och resurser",
    subtitle: "Håll dig uppdaterad med de senaste trenderna och bästa praxis inom hotellgästkommunikation.",
    readMore: "Läs mer",
    viewAll: "Visa alla artiklar"
  },

  // Call to Action section
  cta: {
    title: "Revolutionera din gästkommunikation idag",
    subtitle: "Gå med hundratals fastigheter som använder HostCall.ai för att erbjuda exceptionella gästupplevelser samtidigt som de sparar tid och resurser.",
    button: "Boka Demo",
    trial: "Inget kreditkort krävs. 14 dagars gratis provperiod."
  },

  // Vacation Rental Use Case section
  vacationRental: {
    badge: "Användningsfall",
    title: "Din semesterbostad",
    subtitle: "Se hur HostCall.ai förvandlar gästkommunikation för semesterbostadsägare, från förfrågningar före bokning till recensioner efter utcheckning.",
    benefits: {
      checkin: {
        title: "Automatiserade incheckningssamtal",
        description: "Gäster får personliga ankomstinstruktioner och fastighetsdetaljer automatiskt."
      },
      support: {
        title: "Gäststöd dygnet runt",
        description: "Hantera förfrågningar om bekvämligheter, WiFi och husregler när som helst på dygnet."
      },
      booking: {
        title: "Bokningsbekräftelser",
        description: "Omedelbara bekräftelsesamtal och påminnelser minskar avbokningar avsevärt."
      },
      local: {
        title: "Lokala rekommendationer",
        description: "AI ger personliga tips för restauranger, aktiviteter och sevärdheter."
      }
    },
    cta: "Boka anpassad demo"
  },

  // Integrations section
  integrations: {
    title: "Kraftfulla integrationer",
    subtitle: "Konfigurera ditt Hostcall.ai-konto för att automatisera olika uppgifter och åtgärder med 1-klicks-integrationer",
    cards: {
      make: {
        title: "Make",
        description: "Anslut Hostcall.ai med 1 000+ appar med Make.com för att automatisera röstsamtal, kontaktsynkronisering och realtidsarbetsflöden—ingen kod krävs."
      },
      twilio: {
        title: "Twilio",
        description: "Helt inbäddad i Hostcalls infrastruktur för att tillhandahålla märkestelefonnummer, hantera SMS och driva skalbar röstkommunikation."
      },
      whatsapp: {
        title: "WhatsApp",
        description: "Möjliggör förbättrad automatisering och konversationsflöden via WhatsApp Business, sömlöst integrerat i din Hostcall-drivna infrastruktur."
      },
      googleCalendar: {
        title: "Google Kalender",
        description: "Anslut enkelt Hostcall.ai med din Google Kalender för att möjliggöra realtidsbokning av möten, bekräftelser och ombokning under AI-samtal."
      },
      zapier: {
        title: "Zapier",
        description: "Utlös automatiskt AI-samtal, uppdatera kontaktposter, skicka uppföljningar och synkronisera data över din stack utan att skriva en enda rad kod."
      },
      apis: {
        title: "API:er och Webhooks",
        description: "Anslut till anpassade system och tjänster genom vår robusta API- och webhook-infrastruktur för obegränsade integrationsmöjligheter."
      }
    },
    cta: {
      title: "Anslut Hostcall till 6 000+ appar",
      subtitle: "Anslut enkelt Hostcall med appar som Mailchimp, GoHighLevel, Google formulär, Calendly, Wix, Webflow och många fler med Zapier, Make, API:er och Webhooks.",
      optimize: "Optimera arbetsflöden:",
      optimizeDesc: "Utnyttja integrationens magi för att optimera dina arbetsflöden och uppnå oöverträffad effektivitet och hantera kampanjer anpassade till din verksamhet.",
      button: "Boka en demo",
      trial: "14 dagars gratis provperiod",
      credit: "Gratis 100 kr kredit"
    },
    customIntegration: "Begär anpassad integration"
  },

  // Analytics Reporting section
  analytics: {
    title: "Analys och rapportering",
    subtitle: "Förvandla konversationer till handlingsbara insikter med våra omfattande analys- och rapporteringsverktyg.",
    callAnalytics: "Samtalsanalys",
    daily: "Daglig",
    weekly: "Veckovis",
    monthly: "Månadsvis",
    responseRate: "Svarsfrekvens",
    recentConversation: "Senaste konversation",
    viewAll: "Visa alla",
    incoming: "Inkommande",
    positiveSentiment: "Positiv känsla",
    callDuration: "Samtalslängd",
    export: "Exportera",
    performanceMetrics: {
      title: "Prestationsmått",
      subtitle: "Spåra samtalsvolymer, engagemangsfrekvenser och konverteringsmått i realtid.",
      advancedAnalytics: "Avancerad analys",
      advancedAnalyticsDesc: "Interaktiva instrumentpaneler för djupare insikter",
      avgResponse: "Snitt. svar",
      callsMonth: "Samtal/månad",
      avgDuration: "Snitt. längd"
    },
    transcripts: {
      title: "Transkript och inspelningar",
      subtitle: "Få tillgång till exakta transkript och högkvalitativa samtalsinspelningar för varje konversation.",
      sentimentAnalysis: "Känsloanalys",
      sentimentAnalysisDesc: "Förstå kunders känslor och avsikter",
      breakdown: "Känslofördelning",
      last30Days: "Senaste 30 dagarna",
      positive: "Positiv",
      neutral: "Neutral",
      negative: "Negativ"
    },
    cta: "Boka en demo",
    trial: "14 dagars gratis provperiod",
    credit: "Gratis 100 kr kredit"
  },

  // Campaign Manager section
  campaignManager: {
    title: "Kampanjhanterare för uppsökande verksamhet",
    subtitle: "Hantera och automatisera dina uppsökande kampanjer med precision. Skapa personliga gästkommunikationsflöden som driver engagemang och bokningar.",
    features: {
      messaging: {
        title: "Personliga meddelanden",
        description: "Skapa unika meddelanden anpassade till varje gäst, för att säkerställa en personlig touch som förbättrar deras upplevelse."
      },
      scheduling: {
        title: "Automatiserad schemaläggning",
        description: "Schemalägg meddelanden att skickas vid optimala tidpunkter, maximera engagemang och säkerställ snabb kommunikation."
      },
      multichannel: {
        title: "Flerkanalsstöd",
        description: "Nå gäster på deras föredragna plattformar, oavsett om det är SMS, e-post eller in-app-meddelanden, för sömlös kommunikation."
      }
    },
    dashboard: {
      title: "Instrumentpanelöversikt",
      activeCampaigns: "Aktiva kampanjer",
      totalResults: "Totala resultat",
      responseRate: "Svarsfrekvens",
      fromLastMonth: "från förra månaden",
      recentActivity: "Senaste aktivitet",
      newBooking: "Ny bokning bekräftad",
      guestResponded: "Gäst svarade",
      messageDelivered: "Meddelande levererat"
    },
    analytics: {
      title: "Analys",
      responseRate: "Svarsfrekvens",
      campaignPerformance: "Kampanjprestanda",
      channels: "Kanaler"
    },
    campaigns: {
      title: "Kampanjer",
      newCampaign: "Ny kampanj",
      searchPlaceholder: "Sök kampanjer...",
      filter: "Filtrera",
      sort: "Sortera",
      status: "Status",
      campaign: "Kampanj",
      agent: "Agent",
      noAnswer: "Inget svar",
      results: "Resultat",
      amountSpent: "Belopp spenderat",
      costPerResult: "Kostnad per resultat",
      actions: "Åtgärder",
      live: "Aktiv"
    },
    sidebar: {
      dashboard: "Instrumentpanel",
      campaigns: "Kampanjer",
      analytics: "Analys",
      contacts: "Kontakter",
      settings: "Inställningar"
    },
    cta: "Boka en demo",
    trial: "14 dagars gratis provperiod",
    credit: "Gratis 100 kr kredit"
  },

  // Feature page
  featurePage: {
    hero: {
      title: "Komplett AI-driven automatiserad samtalssuite",
      subtitle: "Upptäck hur hostcall.ai:s intelligenta samtalssystem automatiserar personlig kommunikation i varje skede av gästens resa.",
      demoButton: "Begär demo"
    },
    featureGroups: [
      {
        title: "Automatiserade samtal före vistelse",
        description: "Engagera gäster före ankomst med automatiserade välkomstsamtal som förbereder dem för en exceptionell vistelse.",
        features: [
          "Automatiserade bokningsbekräftelsesamtal",
          "Information före ankomst och FAQ-samtal",
          "Insamling av särskilda önskemål via telefon",
          "Automatiserade incheckning instruktionssamtal",
          "Proaktiva uppgraderingssamtal för rum",
          "Transportkoordineringssamtal"
        ]
      },
      {
        title: "Automatiserade samtal under vistelsen",
        description: "Leverera omedelbar assistans under gästens vistelse med AI-drivna utgående och inkommande samtal.",
        features: [
          "Automatiserade gästförfrågningar dygnet runt",
          "Utgående lokala rekommendationssamtal",
          "Automatiserad hantering av rumsservicesamtal",
          "Problemlösning genom automatiserade samtal",
          "Bekvämlighetsinformation via schemalagda samtal",
          "Förlängningsförfrågningar genom AI-telefonsystem"
        ]
      },
      {
        title: "Automatiserade samtal efter vistelsen",
        description: "Upprätthåll gästrelationer efter utcheckning genom lägliga, personliga uppföljningssamtal.",
        features: [
          "Automatiserade utcheckningsbekräftelsesamtal",
          "Nöjdhetsundersökningssamtal",
          "Automatiserade samtal för recensionsbegäran",
          "Incitamentssamtal för framtida bokningar",
          "Engagemangssamtal för lojalitetsprogram",
          "Personliga årsdag- och specialtillfällesamtal"
        ]
      },
      {
        title: "Flerspråkigt samtalsstöd",
        description: "Bryt språkbarriärer med AI-driven kommunikation på dina gästers föredragna språk.",
        features: [
          "Automatiserade samtal på över 20 språk",
          "Igenkänning av dialekt och accent under samtal",
          "Kulturellt lämpliga röstrespons",
          "Spårning av språkpreferenser för framtida samtal",
          "Kontextmedvetna översättningar i telefonsamtal",
          "Specialiserad hotellterminologi på alla språk"
        ]
      },
      {
        title: "Integration av samtalssystem",
        description: "Anslut vårt automatiserade samtalssystem sömlöst till dina befintliga system för enhetlig drift.",
        features: [
          "PMS-integration för automatiserade samtalsdata (Opera, Mews, etc.)",
          "CRM-synkronisering för personliga samtalsupplevelser",
          "Kanalhanterarkompatibilitet för bokningsrelaterade samtal",
          "Samtalsanalys och rapporteringsverktyg",
          "Automatiserad uppgiftsskapande från samtalsinnehåll",
          "Betalningsbehandling nämns under samtal"
        ]
      },
      {
        title: "Samtalsanalys och insikter",
        description: "Få värdefull data från varje automatiserat gästsamtal för att kontinuerligt förbättra din service.",
        features: [
          "Automatiserad samtalsanalys och trender",
          "Gästnöjdhetsstatistik från samtal",
          "Spårning av vanliga förfrågningar genom samtalsutskrifter",
          "Förbättringar av personaleffektivitet genom samtalsanalys",
          "Identifiering av intäktsmöjligheter från inspelade samtal",
          "Anpassningsbar kontrollpanel för samtalsrapportering"
        ]
      }
    ],
    cta: {
      title: "Redo att förändra din gästsamtalsupplevelse?",
      subtitle: "Gå med hundratals fastigheter som använder hostcall.ai:s automatiserade samtalssystem för att tillhandahålla exceptionell kommunikation genom hela gästens resa.",
      demo: "Begär demo",
      pricing: "Visa priser"
    }
  },

  // Blog Post page
  blogPost: {
    notFound: {
      title: "Blogginlägg hittades inte",
      message: "Tyvärr finns inte blogginlägget du letar efter.",
      backButton: "Tillbaka till bloggen"
    },
    backToArticles: "Tillbaka till alla artiklar",
    minRead: "min läsning",
    cta: {
      title: "Redo att förändra din gästupplevelse?",
      description: "Gå med hundratals hotellföretag som förbättrar sin gästkommunikation med hostcall.ai. Börja din resa mot exceptionella gästupplevelser idag.",
      requestDemo: "Boka Demo",
      contactSales: "Kontakta Försäljning",
      interactive: "Interaktivt verktyg"
    },
    roiCta: {
      title: "Beräkna din ROI",
      description: "Se hur mycket din fastighet kan spara med AI-driven gästkommunikation. Vår interaktiva kalkylator visar din personliga ROI på under 2 minuter.",
      button: "Öppna ROI-kalkylatorn"
    },
    relatedArticles: "Relaterade Artiklar",
    readMore: "Läs Mer",
    newsletter: {
      title: "Håll dig uppdaterad med branschinsikter",
      subtitle: "Prenumerera på vårt nyhetsbrev och få de senaste trenderna och tipsen inom hotellbranschen direkt i din inkorg.",
      placeholder: "Ange din e-postadress",
      button: "Prenumerera"
    }
  },


  // 404 Not Found Page
  notFound: {
    title: "404",
    heading: "Sidan Hittades Inte",
    message: "Vi beklagar, sidan du söker kunde inte hittas. Kontrollera URL:en eller navigera tillbaka till startsidan.",
    button: "Tillbaka till Startsidan"
  },

  // SEO Meta Tags - Optimerat för hotellchefer, hospitality managers, CTO:er
  seo: {
    siteName: "HostCall.ai",
    titleSuffix: " | HostCall.ai",
    
    home: {
      title: "AI-driven gästkommunikation för hotell och semesterboenden | HostCall.ai",
      description: "Missa aldrig en bokning igen. HostCall.ai hanterar obegränsade gästsamtal dygnet runt på 20+ språk. Betrodd av 200+ hotellfastigheter.",
      keywords: "AI gästkommunikation, hotellautomatisering, semesterboende AI, hospitality teknologi, dygnet runt gäststöd, flerspråkig hotellprogramvara"
    },
    
    features: {
      title: "AI-röstagenttfunktioner för hotellbranschen | HostCall.ai",
      description: "Samtalshantering dygnet runt, stöd för 20+ språk, PMS-integration, realtidsanalys. Se hur HostCall.ai förändrar gästkommunikation för hotell.",
      keywords: "hotell AI funktioner, röst AI hospitality, PMS integration, gästkommunikation automatisering"
    },
    
    pricing: {
      title: "Enkel, transparent prissättning för hotell | HostCall.ai",
      description: "Flexibla prisplaner för fastigheter i alla storlekar. Från boutiquehotell till stora hotellkedjor. Inga dolda avgifter. Börja med en gratis demo.",
      keywords: "hotell AI prissättning, hotellprogramvara kostnad, semesterboende automatisering pris"
    },
    
    about: {
      title: "Om HostCall.ai - Förändrar kommunikationen inom hotellbranschen",
      description: "Grundat av hotellveteraner och AI-experter. Lär dig hur HostCall.ai revolutionerar gästkommunikation för 200+ fastigheter världen över.",
      keywords: "HostCall.ai företag, hospitality AI startup, hotellteknologiföretag"
    },
    
    contact: {
      title: "Kontakta våra hospitality AI-experter | HostCall.ai",
      description: "Kontakta vårt team. Boka en demo, ställ frågor eller utforska partnerskapsmöjligheter. Vi svarar inom 24 timmar.",
      keywords: "kontakta HostCall.ai, hospitality AI demo, hotellprogramvara konsultation"
    },
    
    demo: {
      title: "Boka din gratis demo - Se HostCall.ai i aktion",
      description: "Boka en personlig demo och se hur HostCall.ai kan öka dina bokningar med 35%. Gratis konsultation med våra hospitality AI-experter.",
      keywords: "HostCall.ai demo, hotell AI demonstration, gratis hospitality programvara test"
    },
    
    blog: {
      title: "Insikter och AI-trender inom hotellbranschen | HostCall.ai Blogg",
      description: "Expertartiklar om AI inom hospitality, gästkommunikationsstrategier och hotellteknologitrender. Håll dig uppdaterad med HostCall.ai.",
      keywords: "hospitality blogg, hotell AI trender, gästkommunikation tips"
    },
    
    careers: {
      title: "Gå med i vårt team - Karriär på HostCall.ai",
      description: "Hjälp oss förändra hotellbranschen. Distansarbete, konkurrenskraftiga förmåner, meningsfullt arbete. Se lediga tjänster.",
      keywords: "HostCall.ai karriär, hospitality tech jobb, AI startup jobb"
    },
    
    businessCases: {
      title: "Kundframgångshistorier - Hotell som använder AI | HostCall.ai",
      description: "Upptäck hur ledande hotell och semesterboenden ökade bokningarna med 35% med HostCall.ai. Läs verkliga framgångshistorier.",
      keywords: "hotell AI fallstudier, hospitality framgångshistorier, semesterboende automatisering resultat"
    },
    
    notFound: {
      title: "Sidan hittades inte | HostCall.ai",
      description: "Sidan du söker finns inte. Återvänd till HostCall.ai startsida för att utforska AI-drivna gästkommunikationslösningar."
    },
    
    apiDocs: {
      title: "API-dokumentation - Integrera HostCall.ai | Utvecklarguide",
      description: "Komplett REST API-dokumentation för HostCall.ai. Integrera AI-röstagenter i ditt hotell-PMS, bokningssystem eller fastighetshanteringsprogram.",
      keywords: "HostCall.ai API, hotell API-integration, hospitality utvecklardokumentation, röst-AI API"
    },
    
    faq: {
      title: "Vanliga frågor - HostCall.ai",
      description: "Hitta svar på vanliga frågor om HostCall.ai:s AI-röstassistent för hotell och semesterboenden.",
      keywords: "HostCall.ai vanliga frågor, AI-assistent frågor, hospitality AI hjälp"
    }
  },

  // API Documentation
  apiDocs: {
    pageTitle: "Hostcall.ai API-dokumentation",
    pageSubtitle: "Integrera våra kraftfulla AI-röstagenter för hotellbranschen direkt i dina system med vårt omfattande REST API.",
    
    nav: {
      title: "API-dokumentation",
      gettingStarted: "Kom igång",
      authentication: "Autentisering",
      apiReference: "API-referens",
      endpoints: "Ändpunkter",
      errorCodes: "Felkoder",
      rateLimits: "Hastighetsbegränsningar",
      examples: "Exempel"
    },
    
    gettingStarted: {
      title: "Kom igång",
      baseUrl: "Bas-URL",
      baseUrlDescription: "Alla API-förfrågningar ska göras till bas-URL:en ovan. HTTPS krävs för alla API-förfrågningar.",
      requestFormat: "Förfrågningsformat",
      requestFormatDescription: "Vårt API accepterar formulärkodade förfrågningskroppar, JSON-förfrågningskroppar och stöder sökvägsparametrar. Dokumentationen för varje ändpunkt specificerar det förväntade formatet."
    },
    
    authentication: {
      title: "Autentisering",
      apiKeys: "API-nycklar",
      apiKeysDescription: "Autentisering utförs med API-nycklar. Varje API-förfrågan kräver antingen en konto-API-nyckel eller en projekt-API-nyckel.",
      authHeader: "Autentiseringshuvud",
      securityWarning: "Håll dina API-nycklar säkra! Dela dem aldrig i offentligt tillgängliga områden som GitHub eller klientkod.",
      keyTypes: "Nyckeltyper",
      accountKey: "Konto-API-nyckel",
      accountKeyDesc: "Används för att hantera resurser på kontonivå och hämta användningsinformation.",
      projectKey: "Projekt-API-nyckel",
      projectKeyDesc: "Används för projektspecifika operationer som att skapa och hantera samtal.",
      exampleRequest: "Exempel på autentiseringsförfrågan"
    },
    
    apiReference: {
      title: "API-referens",
      resources: "Resurser",
      resourcesDescription: "API:et är organiserat kring följande resurser:",
      projects: "Projekt",
      projectsDesc: "Hantera projekt inom ditt konto",
      agents: "Agenter",
      agentsDesc: "Konfigurera och hantera AI-röstagenter",
      calls: "Samtal",
      callsDesc: "Skapa och hantera utgående samtal",
      webhooks: "Webhooks",
      webhooksDesc: "Konfigurera ändpunkter för att ta emot uppdateringar i realtid"
    },
    
    endpoints: {
      title: "Ändpunkter",
      projects: "Projekt",
      agents: "Agenter",
      calls: "Samtal",
      webhooks: "Webhooks",
      listProjects: "Lista alla projekt i ditt konto.",
      getProject: "Hämta information om ett specifikt projekt.",
      listAgents: "Lista alla tillgängliga röstagenter för ett specifikt projekt.",
      createAgent: "Skapa en ny röstagent för ett projekt.",
      createCall: "Skapa ett nytt utgående samtal med en röstagent.",
      getCall: "Hämta information om ett specifikt samtal.",
      createWebhook: "Skapa en ny webhook-ändpunkt för att ta emot uppdateringar om samtal i realtid.",
      pathParameters: "Sökvägsparametrar",
      requestBody: "Förfrågningskropp",
      response: "Svar"
    },
    
    errorCodes: {
      title: "Felkoder",
      description: "Hostcall.ai API använder konventionella HTTP-svarskoder för att indikera om en API-förfrågan lyckades eller misslyckades:",
      code: "Kod",
      codeDescription: "Beskrivning",
      responseFormat: "Felsvarets format",
      codes: {
        ok: "Allt fungerade som förväntat",
        badRequest: "Förfrågan var oacceptabel, ofta på grund av en saknad obligatorisk parameter",
        unauthorized: "Ingen giltig API-nyckel tillhandahölls",
        forbidden: "API-nyckeln har inte behörighet att utföra förfrågan",
        notFound: "Den begärda resursen finns inte",
        tooManyRequests: "För många förfrågningar skickades till API:et för snabbt",
        serverErrors: "Något gick fel på Hostcall.ai:s sida"
      }
    },
    
    rateLimits: {
      title: "Hastighetsbegränsningar",
      description: "API:et implementerar hastighetsbegränsning för att säkerställa stabilitet och rättvis användning. Begränsningarna varierar beroende på ändpunkt och plan:",
      plan: "Plan",
      endpoint: "Ändpunkt",
      rateLimit: "Hastighetsbegränsning",
      otherEndpoints: "Övriga ändpunkter",
      requestsPerMinute: "förfrågningar/minut",
      headersDescription: "Hastighetsbegränsningshuvuden ingår i alla API-svar:"
    },
    
    examples: {
      title: "Kodexempel",
      reservationCall: "Skapa ett utgående bokningsbekräftelsesamtal"
    },
    
    cta: {
      title: "Redo att komma igång?",
      subtitle: "Skapa ditt konto och hämta dina API-nycklar.",
      button: "Registrera dig för API-åtkomst"
    }
  },
  
  // FAQ Page (dedicated page)
  faqPage: {
    hero: {
      title: "Vanliga frågor",
      subtitle: "Hitta svar på vanliga frågor om HostCall.ai:s AI-drivna gästkommunikationsplattform.",
      searchPlaceholder: "Sök efter svar..."
    },
    filter: {
      all: "Alla frågor",
      general: "Allmänt",
      pricing: "Priser & planer",
      technical: "Tekniskt",
      setup: "Installation & onboarding",
      privacy: "Integritet & säkerhet"
    },
    noResults: "Inga frågor hittades som matchar din sökning.",
    clearFilters: "Rensa filter",
    categories: {
      general: {
        title: "Allmänna frågor",
        questions: [
          {
            q: "Vad är HostCall.ai?",
            a: "HostCall.ai är en AI-driven röstassistentplattform speciellt utformad för hotellbranschen. Den hanterar gästsamtal dygnet runt, svarar på frågor om bokningar, bekvämligheter och lokala rekommendationer, och integreras sömlöst med dina befintliga fastighetshanteringssystem."
          },
          {
            q: "Hur fungerar AI-röstassistenten?",
            a: "Vår AI använder avancerad naturlig språkbehandling för att förstå gästförfrågningar och svara korrekt. Den integreras med ditt fastighetshanteringssystem för att komma åt bokningsinformation och kan hantera komplexa samtal om bekvämligheter, lokala rekommendationer och gästtjänster."
          },
          {
            q: "Kan AI:n hantera flera språk?",
            a: "Ja, vår AI-röstassistent stöder över 20 språk och kan automatiskt identifiera den uppringandes föredragna språk. Detta säkerställer att internationella gäster får support på sitt modersmål, vilket förbättrar deras upplevelse."
          },
          {
            q: "Vilka typer av fastigheter kan använda HostCall.ai?",
            a: "HostCall.ai är utformat för hotell i alla storlekar, semesterbostäder, boutiquehotell, resortkedjor och fastighetsförvaltningsbolag. Vår plattform skalar från enskilda fastigheter till stora portföljer med hundratals enheter."
          },
          {
            q: "Kan jag anpassa AI:ns personlighet och svar?",
            a: "Absolut. Du kan anpassa AI:ns röst, personlighet, ton och svar för att matcha ditt varumärke. Vi arbetar med dig under installationen för att säkerställa att AI:n representerar din fastighet perfekt."
          },
          {
            q: "Vad händer om AI:n inte kan svara på en fråga?",
            a: "AI:n är utformad för att hantera 90%+ av vanliga gästförfrågningar. För komplexa frågor som den inte kan lösa, överför den sömlöst samtalet till din personal med en sammanfattning av konversationen och gästens behov."
          }
        ]
      },
      pricing: {
        title: "Priser & planer",
        questions: [
          {
            q: "Finns det en installationsavgift?",
            a: "Inga installationsavgifter. Vi inkluderar onboarding, integration och utbildning i din månadsabonnemang. Du betalar bara månadsavgiften baserat på din valda plan."
          },
          {
            q: "Erbjuder ni en gratis provperiod?",
            a: "Ja! Vi erbjuder en 14-dagars gratis provperiod med full tillgång till alla funktioner. Inget kreditkort krävs för att starta. Du kan uppleva hela kraften i HostCall.ai innan du gör något åtagande."
          },
          {
            q: "Vilka betalningsmetoder accepterar ni?",
            a: "Vi accepterar alla större kreditkort (Visa, Mastercard, American Express), banköverföringar och kan ställa in fakturering för Enterprise-kunder med årskontrakt."
          },
          {
            q: "Kan jag uppgradera eller nedgradera min plan?",
            a: "Ja, du kan ändra din plan när som helst. Uppgraderingar träder i kraft omedelbart, och nedgraderingar tillämpas i slutet av din nuvarande faktureringsperiod. Inga straffavgifter eller dolda avgifter."
          },
          {
            q: "Erbjuder ni rabatter för årsfakturering?",
            a: "Ja, vi erbjuder betydande rabatter för årsåtaganden. Kontakta vårt säljteam för att diskutera årspriser och anpassade företagsavtal."
          }
        ]
      },
      technical: {
        title: "Tekniskt & integrationer",
        questions: [
          {
            q: "Vilka fastighetshanteringssystem integrerar ni med?",
            a: "Vi stöder alla större PMS-plattformar inklusive Opera, Mews, Cloudbeds, Guesty, Hostaway och många andra. Vi erbjuder också ett robust API för anpassade integrationer."
          },
          {
            q: "Integrerar ni med bokningsplattformar?",
            a: "Ja, HostCall.ai integreras med stora OTA:er och bokningsplattformar inklusive Airbnb, Booking.com, Vrbo, Expedia och direktbokningssystem."
          },
          {
            q: "Finns det ett API tillgängligt?",
            a: "Ja, vi tillhandahåller ett omfattande REST API för utvecklare som vill bygga anpassade integrationer. Vår API-dokumentation inkluderar exempel på flera programmeringsspråk."
          },
          {
            q: "Hur säker är min data?",
            a: "Vi tar säkerhet på allvar. All data krypteras under överföring och i vila. Vi är SOC 2-kompatibla och följer GDPR-riktlinjer. Vi delar aldrig din data med tredje part."
          },
          {
            q: "Kan jag använda mina befintliga telefonnummer?",
            a: "Ja, du kan porta dina befintliga telefonnummer till HostCall.ai eller använda nya nummer som vi tillhandahåller åt dig. Vi stöder lokala nummer i 50+ länder."
          }
        ]
      },
      setup: {
        title: "Installation & onboarding",
        questions: [
          {
            q: "Hur snabbt kan jag sätta upp systemet?",
            a: "Installation tar vanligtvis 24-48 timmar. Vi konfigurerar AI:n med din fastighetsinformation, integrerar med dina befintliga system och ger utbildning till ditt team. De flesta fastigheter är i drift inom 2 arbetsdagar."
          },
          {
            q: "Tillhandahåller ni utbildning?",
            a: "Ja, alla planer inkluderar omfattande onboarding och utbildning. Vårt kundframgångsteam guidar dig genom installationen, visar dig hur du använder instrumentpanelen och säkerställer att ditt team är bekvämt med systemet."
          },
          {
            q: "Kan jag lägga till fler fastigheter senare?",
            a: "Absolut. Du kan lägga till nya fastigheter när som helst via din instrumentpanel. Varje fastighet kan ha sin egen anpassade AI-konfiguration samtidigt som de delar ett centralt hanteringsgränssnitt."
          },
          {
            q: "Vilken information behöver ni från mig för att komma igång?",
            a: "Vi behöver grundläggande fastighetsinformation, dina PMS-uppgifter för integration och dina föredragna AI-personlighetsinställningar. Vårt onboarding-team guidar dig genom att samla in allt som behövs."
          }
        ]
      },
      privacy: {
        title: "Integritet & säkerhet",
        questions: [
          {
            q: "Hur hanterar ni gästdata?",
            a: "Gästdata behandlas i enlighet med GDPR och andra integritetsförordningar. Vi lagrar endast data som är nödvändig för tjänsteleverans, och du kan begära dataradering när som helst."
          },
          {
            q: "Spelas samtal in?",
            a: "Samtalsinspelning är valfri och kan aktiveras/avaktiveras efter dina preferenser. Om aktiverad lagras inspelningar säkert och kan användas för kvalitetssäkring och utbildningsändamål."
          },
          {
            q: "Var lagras data?",
            a: "Data lagras i säkra, SOC 2-kompatibla datacenter. Europeiska kunders data lagras i EU-datacenter för att uppfylla GDPR:s krav på dataresidency."
          },
          {
            q: "Kan gäster välja bort AI-samtal?",
            a: "Ja, gäster kan alltid begära att prata med en människa. AI:n överför sömlöst samtalet till din personal om så begärs, vilket säkerställer att gäster alltid har möjlighet till mänsklig interaktion."
          }
        ]
      }
    },
    contact: {
      title: "Har du fortfarande frågor?",
      subtitle: "Vårt team finns här för att hjälpa. Kontakta oss via någon av dessa kanaler.",
      chat: {
        title: "Livechatt",
        description: "Chatta med vårt supportteam i realtid.",
        button: "Starta chatt"
      },
      email: {
        title: "E-postsupport",
        description: "Vi svarar inom 24 timmar.",
        button: "Skicka e-post"
      },
      phone: {
        title: "Telefonsupport",
        description: "Prata med en riktig person.",
        button: "Ring oss"
      }
    },
    cta: {
      title: "Redo att förändra din gästkommunikation?",
      subtitle: "Gå med hundratals fastigheter som redan använder HostCall.ai för att erbjuda exceptionella gästupplevelser.",
      demoButton: "Begär gratis demo",
      contactButton: "Kontakta försäljning"
    }
  },

  // ROI Wizard
  roiWizard: {
    title: "ROI-kalkylator",
    quickMode: "Snabbkalkyl",
    fullMode: "Fullständig analys",
    steps: {
      basics: { title: "Grundläggande", subtitle: "Berätta om din verksamhet" },
      revenue: { title: "Intäktspåverkan", subtitle: "Förstå kostnaden av missade samtal" },
      costs: { title: "Kostnadsanalys", subtitle: "Nuvarande personalkostnader" },
      results: { title: "Dina resultat", subtitle: "Se dina potentiella besparingar" },
      actions: { title: "Vidta åtgärder", subtitle: "Börja spara idag" }
    },
    labels: {
      callsPerMonth: "Samtal per månad",
      properties: "Antal fastigheter",
      missedPercent: "Missade samtal %",
      salesPercent: "Försäljningssamtal %",
      avgOrder: "Snittvärde per vistelse",
      staffHours: "Personaltimmar/vecka för gästkommunikation",
      hourlyCost: "Timkostnad personal",
      howWeCalc: "Hur vi räknar"
    },
    results: {
      totalAnnual: "Total årlig påverkan",
      revenueLost: "Förlorade intäkter",
      promoterImpact: "Ambassadörspåverkan",
      costSavings: "Kostnadsbesparingar",
      paybackPeriod: "Återbetalningstid",
      months: "månader",
      yearOneROI: "År 1 ROI",
      breakEven: "Break-even nås",
      perYear: "per år"
    },
    promoter: {
      title: "Förlorade ambassadörer",
      description: "Dålig support = missnöjda gäster = ingen mun-till-mun. Med {count} förlorade ambassadörer per månad."
    },
    costs: {
      currentCost: "Nuvarande kostnad",
      withHostcall: "Med HostCall.ai"
    },
    chart: {
      title: "12-månaders påverkan",
      without: "Utan",
      with: "Med"
    },
    comparison: {
      title: "Branschjämförelse",
      you: "Du",
      industryAvg: "Genomsnitt",
      top25: "Topp 25%",
      yourRoi: "Din ROI",
      elitePerformer: "Elitnivå",
      aboveAverage: "Över genomsnitt",
      topPerformer: "Toppnivå!"
    },
    scenarios: {
      saveScenario: "Spara scenario",
      compare: "Jämför",
      savedScenarios: "Sparade scenarier",
      noScenarios: "Inga sparade scenarier än",
      loadScenario: "Ladda",
      deleteScenario: "Ta bort"
    },
    actions: {
      next: "Nästa",
      back: "Tillbaka",
      done: "Klar",
      getReport: "Se hela rapporten",
      downloadPdf: "Ladda ner PDF-rapport",
      emailReport: "Skicka rapport till e-post",
      bookDemo: "Boka demo",
      freeTrial: "Starta gratis provperiod",
      send: "Skicka",
      download: "Ladda ner",
      startNow: "Starta nu"
    },
    quick: {
      title: "Snabb ROI-uppskattning",
      subtitle: "3 inputs, direkta resultat",
      annualSavings: "Uppskattade årliga besparingar",
      payback: "Återbetalningstid",
      roi: "År 1 ROI",
      getDetailed: "Få detaljerad analys",
      disclaimer: "* Använder branschgenomsnitt: 40% missade samtal, 20% säljsamtal, 250 kr/h personal"
    },
    email: {
      getDetailedPdf: "Få en detaljerad PDF-rapport",
      nameOptional: "Namn (valfritt)",
      reportSent: "Rapport skickad! Kolla din inbox.",
      shareWithTeam: "Dela med ditt team"
    },
    cta: {
      startSavingToday: "Börja spara idag!",
      takeNextStep: "Ta nästa steg för att fånga varje samtal",
      seeInAction: "Se HostCall.ai i aktion",
      daysFreeTrial: "14 dagar gratis, inget kort krävs"
    },
    celebration: {
      fastPayback: "Fantastiskt! Mindre än 3 månaders återbetalningstid!"
    }
  },
  
  // Follow modal
  followModal: {
    neverMiss: "Missa aldrig en story från",
    subtitle: "Registrera dig för att se storyer från {authorName} och tusentals andra skribenter på HostCall.ai.",
    signUpGoogle: "Registrera med Google",
    signUpEmail: "Registrera med e-post",
    alreadyHaveAccount: "Har du redan ett konto?",
    signIn: "Logga in"
  },
  
  // Admin
  admin: {
    responses: {
      title: "Svar",
      description: "Hantera och moderera användarkommentarer på alla artiklar.",
      columns: {
        article: "Artikel",
        commenter: "Kommentator",
        content: "Innehåll",
        date: "Datum",
        status: "Status",
        actions: "Åtgärder"
      },
      status: {
        all: "Alla",
        pending: "Väntande",
        approved: "Godkänd",
        rejected: "Avvisad",
        spam: "Spam"
      },
      actions: {
        approve: "Godkänn",
        reject: "Avvisa",
        markSpam: "Markera som spam",
        delete: "Ta bort"
      },
      empty: "Inga kommentarer ännu"
    },
    followers: {
      title: "Följare",
      description: "Visa alla användare som följer bloggförfattare.",
      totalFollowers: "Totalt antal följare",
      columns: {
        follower: "Följare",
        email: "E-post",
        following: "Följer",
        since: "Sedan"
      },
      exportCsv: "Exportera CSV",
      empty: "Inga följare ännu"
    }
  }
};